<template>
  <el-dialog
    :title="$t('reportCustomComponentFooterManage.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item :label="$t('reportCustomComponentFooterManage.name')" prop="name" required>
        <el-input
          v-model="formData.name"
          :placeholder="$t('reportCustomComponentFooterManage.nameRequired')"
          style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reportCustomComponentFooterManage.queryMethod')" prop="queryModel" required>
        <el-select
          v-model="formData.queryModel"
          :placeholder="$t('reportCustomComponentFooterManage.queryMethodRequired')"
          style="width: 100%">
          <el-option label="SQL" value="1"></el-option>
          <el-option label="Java" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="formData.queryModel === '1'" label="SQL">
        <el-input
          type="textarea"
          v-model="formData.componentSql"
          :placeholder="$t('reportCustomComponentFooterManage.sqlOptional')"
          :rows="15"
          style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item v-if="formData.queryModel === '2'" label="Java">
        <el-input
          type="textarea"
          v-model="formData.javaScript"
          :placeholder="$t('reportCustomComponentFooterManage.javaOptional')"
          :rows="15"
          style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reportCustomComponentFooterManage.description')">
        <el-input
          type="textarea"
          v-model="formData.remark"
          :placeholder="$t('reportCustomComponentFooterManage.descriptionOptional')"
          style="width: 100%"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="handleSubmit">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateReportCustomComponentFooter } from '@/api/dev/reportCustomComponentFooterApi'

export default {
  name: 'EditReportCustomComponentFooter',
  data() {
    return {
      dialogVisible: false,
      formData: {
        footerId: '',
        componentId: '',
        name: '',
        queryModel: '',
        javaScript: '',
        componentSql: '',
        remark: ''
      }
    }
  },
  methods: {
    open(params) {
      this.formData = { ...params }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.formData = {
        footerId: '',
        componentId: '',
        name: '',
        queryModel: '',
        javaScript: '',
        componentSql: '',
        remark: ''
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await updateReportCustomComponentFooter(this.formData)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('common.submitSuccess'))
      } catch (error) {
        console.error('更新失败:', error)
      }
    }
  }
}
</script>